/**
 * 세션 종료 이벤트. 토큰 갱신이 **거절(rejected)** 됐을 때만 난다.
 * 서버에 닿지 못한 경우(unreachable)에는 나지 않는다 — 서버 재시작이 전원 로그아웃이 되지 않게.
 */
export type SessionExpiredListener = () => void;

const listeners = new Set<SessionExpiredListener>();

export function onSessionExpired(listener: SessionExpiredListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitSessionExpired(): void {
  for (const listener of listeners) {
    try {
      listener();
    } catch {
      // 무시
    }
  }
}
